<script>
    import {replace} from 'svelte-spa-router'
    import Cookies from 'js-cookie'
    import { fade } from 'svelte/transition';
    import Empty from './layout/Empty.svelte';
    import Session from "../class/Session";
    import { t } from "../i18n";
    import LanguageSelect from "../i18n/LanguageSelect.svelte";


    $: busy = false;
    $: error = null;
    $: loading = false;

    let lastLogin = Cookies.get('_defaultLogin')||'';
    let loginElem;
    let passwordElemt;


    let doLogin = async()=>
    {
        try {
            busy = true;
            error = null;

            let login = loginElem.value; if(!login) throw $t('login.err_username');
            let password = passwordElemt.value; if(!password) throw $t('login.err_password');

            let ok = await Session.tryLogin(login, password);
            if(!ok) throw $t('login.err_auth');

            loading = true;

            setTimeout(function(){
                location.reload();
            }, 1000);

        }catch(err){
            error = err;
        }finally{
            busy = false;
        }
    };

</script>


<Empty title={$t('page.login')}>

    <div class="app-content content">
        <div class="content-overlay"></div>
        <div class="content-wrapper">
            <div class="content-header row"></div>
            <div class="content-body">
                <section class="row flexbox-container">
                    <div class="col-xl-7 col-10">
                        <div class="card bg-authentication mb-0" style="background:white;">
                            <div class="row m-0">
                                <!-- left lock screen section -->
                                <div class="col-md-6 col-12 px-0">
                                    <div class="card disable-rounded-right mb-0 p-2" style="background: #f2f4f4;">
                                        <div style="position:absolute; top:10px; right:10px; z-index:2;"><LanguageSelect></LanguageSelect></div>
                                        <div class="card-header pb-1">
                                            <div class="card-title">
                                                <h4 class="text-center mb-2">{$t('login.title')}</h4>
                                            </div>
                                        </div>
                                        <div class="card-content">
                                            <div class="card-body">

                                                {#if error}
                                                    <p style="color:red;" transition:fade>{error}</p>
                                                {/if}

                                                {#if loading}
                                                    <p style="color:gray;position:absolute;" transition:fade>{$t('login.loading')}</p>
                                                {/if}

                                                <form  action="./?p=login" method="POST" disabled={busy}  on:submit|preventDefault={doLogin} style="visibility: {loading?'hidden':'visible'}">
                                                    <input type="hidden" name="_action" value="login" />
                                                    <div class="form-group mb-50">
                                                        <label class="text-bold-600" for="input1">{$t('login.username')}</label>
                                                        <input disabled={busy} bind:this={loginElem} autofocus  type="text" name="login" class="form-control input-login" id="input1" placeholder={$t('login.username')} data-id="login" value={lastLogin} />
                                                    </div>
                                                    <div class="form-group">
                                                        <label class="text-bold-600" for="input2">{$t('login.password')}</label>
                                                        <input disabled={busy} bind:this={passwordElemt} type="password" name="password" class="form-control input-pass" id="input2" placeholder={$t('login.password')} data-id="password" />
                                                    </div>


                                                    <button disabled={busy}  type="submit" class="btn btn-primary position-relative w-100 login-btn">{$t('login.button')}<i id="icon-arrow" class="bx bx-right-arrow-alt"></i></button>
                                                </form>



                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- right image section -->
                                <div class="col-md-6 d-md-block d-none text-center align-self-center">
                                    <img class="img-fluid" src="assets/img/logo.png" alt="branding logo" >
                                    <div style="position:absolute;bottom: -32px;right:0;width: 100%;text-align: right;padding-right: 4rem;font-size:0.8em;">
                                        {$t('login.by')}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>




            </div>
        </div>
    </div>
</Empty>